<template>
    <b-sidebar
        id="sidebar-assistente-desk"
        v-model="visivel"
        :width="largura"
        right
        shadow
        backdrop
        no-header
        @shown="montaWidget"
    >
        <!-- Sem cabecalho nosso: o widget embutido ja traz o dele (titulo,
             menu e fechar). O X dele fecha a sidebar pelo evento 'close'. -->
        <div
            id="area-assistente-desk"
            class="area-assistente-desk"
        ></div>
        <!-- Identidade + script + init levam ~1s: sem isso a sidebar abre
             branca e parece bug. Esqueleto de conversa com brilho, como os
             chats de mercado; some depois da primeira montagem. -->
        <div
            v-if="!carregado"
            class="carregando-assistente-desk"
            aria-hidden="true"
        >
            <div class="cad-topo">
                <div class="cad-avatar cad-brilho"></div>
                <div class="cad-titulos">
                    <div class="cad-linha cad-brilho" style="width: 45%"></div>
                    <div class="cad-linha cad-brilho" style="width: 70%"></div>
                </div>
            </div>
            <div class="cad-balao cad-brilho" style="width: 75%"></div>
            <div class="cad-balao curto cad-brilho" style="width: 55%"></div>
            <div class="cad-balao direita cad-brilho" style="width: 65%"></div>
            <div class="cad-balao curto cad-brilho" style="width: 45%"></div>
        </div>
    </b-sidebar>
</template>
<script>
import { abreChatDesk } from '@/shared/plugins/chatDesk'
export default {
    name: 'AssistenteDesk',
    data() {
        return {
            visivel: false,
            montando: false,
            carregado: false,
            expandido: false,
            rolagemAnterior: null
        }
    },
    computed: {
        largura() {
            if (this.$isMobile()) {
                return '100%'
            }
            // Modo largo do widget (botao de expandir): a sidebar acompanha.
            // min() protege monitor estreito — nunca passa da janela.
            return this.expandido ? 'min(900px, 100vw)' : '450px'
        }
    },
    watch: {
        visivel(aberto) {
            this.travaRolagemPagina(aberto)
            // Lembra o estado por aba: F5 nao fecha o assistente. Se a
            // montagem falhar, o proprio montaWidget fecha e o registro sai.
            if (aberto) {
                sessionStorage.setItem('assistente_desk_aberto', '1')
            } else {
                sessionStorage.removeItem('assistente_desk_aberto')
            }
        }
    },
    mounted() {
        this.$root.$on('abrir-assistente-desk', this.abrir)
        // Estava aberto antes do refresh? Reabre: o widget remonta com a
        // mesma identidade e o Desk retoma a conversa de onde estava.
        if (sessionStorage.getItem('assistente_desk_aberto')) {
            this.abrir()
        }
    },
    beforeDestroy() {
        this.$root.$off('abrir-assistente-desk', this.abrir)
        this.travaRolagemPagina(false)
    },
    methods: {
        abrir() {
            this.visivel = true
        },
        fechar() {
            this.visivel = false
        },
        // O widget avisa com true/false a cada clique no expandir. O estado
        // interno dele sobrevive a fechar/reabrir a sidebar (o widget segue
        // montado), entao guardar o valor do evento mantem os dois em sincronia.
        aoExpandir(largo) {
            this.expandido = !!largo
        },
        // Com o assistente aberto o chat tem a rolagem dele; a da pagina atras
        // so cria uma segunda barra e rola o conteudo por baixo do painel.
        travaRolagemPagina(travar) {
            // O AdminLTE rola ora no body, ora no html (e o .right-side tem
            // rolagem propria em algumas telas): trava os tres, guardando o
            // valor anterior de cada um para devolver exatamente como estava.
            const alvos = [
                document.documentElement,
                document.body,
                document.querySelector('.right-side')
            ].filter(Boolean)

            if (travar) {
                if (this.rolagemAnterior === null) {
                    this.rolagemAnterior = alvos.map(el => el.style.overflow || '')
                }
                alvos.forEach(el => { el.style.overflow = 'hidden' })
                return
            }
            if (this.rolagemAnterior !== null) {
                alvos.forEach((el, i) => { el.style.overflow = this.rolagemAnterior[i] || '' })
                this.rolagemAnterior = null
            }
        },
        // Só monta depois que a sidebar apareceu: o widget precisa do
        // elemento no DOM para se ancorar nele.
        async montaWidget() {
            if (this.montando) {
                return
            }
            this.montando = true
            const abriu = await abreChatDesk({
                container: '#area-assistente-desk',
                aoFechar: this.fechar,
                aoExpandir: this.aoExpandir
            })
            if (!abriu) {
                this.visivel = false
            } else {
                this.carregado = true
            }
            this.montando = false
        }
    }
}
</script>
<style>
#sidebar-assistente-desk {
    background: #fff !important;
    /* Alarga/estreita suave ao expandir pelo botao do widget. */
    transition: width 0.25s ease;
}
#sidebar-assistente-desk .b-sidebar-body {
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;
}
.area-assistente-desk {
    flex: 1 1 auto;
    min-height: 0;
}
.carregando-assistente-desk {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 20px;
    background: #fff;
}
.carregando-assistente-desk .cad-topo {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
}
.carregando-assistente-desk .cad-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    flex: 0 0 auto;
}
.carregando-assistente-desk .cad-titulos {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.carregando-assistente-desk .cad-linha {
    height: 10px;
    border-radius: 5px;
}
.carregando-assistente-desk .cad-balao {
    height: 56px;
    border-radius: 14px 14px 14px 4px;
}
.carregando-assistente-desk .cad-balao.curto {
    height: 36px;
}
.carregando-assistente-desk .cad-balao.direita {
    align-self: flex-end;
    border-radius: 14px 14px 4px 14px;
}
.carregando-assistente-desk .cad-brilho {
    background: linear-gradient(90deg, #eef1f4 25%, #f7f9fb 50%, #eef1f4 75%);
    background-size: 400% 100%;
    animation: cad-brilho 1.4s ease-in-out infinite;
}
@keyframes cad-brilho {
    0% { background-position: 100% 0; }
    100% { background-position: 0 0; }
}
@media (max-width: 768px) {
    #sidebar-assistente-desk,
    #sidebar-assistente-desk.b-sidebar,
    .b-sidebar#sidebar-assistente-desk {
        width: 100% !important;
        max-width: 100vw !important;
        min-width: 100% !important;
    }
}
</style>
